import footerStyle from "./Footer.module.css"

function Footer() {
    return (
        <div className={footerStyle.footer}>
            Designed and build by <b>Abhishek Khanna</b> , 2022 All right reserved.
        </div>
    )
}

export default Footer